<div class="day-selector">
  <button
    type="button"
    *ngFor="let day of days"
    (click)="toggleDay(day.value)"
    [class.selected]="isSelected(day.value)"
    [attr.title]="day.full"
  >
    {{ day.label }}
  </button>
</div>
<mat-error *ngIf="controlCampo.invalid && (controlCampo.dirty || controlCampo.touched)">
  Debes seleccionar al menos un día de la semana.
</mat-error>